var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_vm._v(" Copyright 2012 - "+_vm._s(_vm.year)+" OBOSITII.org ")])])}
var staticRenderFns = []

export { render, staticRenderFns }